import axiosInstance from "../Interceptors/axiosInstance.jsx";
import Cookies from "js-cookie";
import { assertValidPathSegment } from "../utils/apiPathUtils";

const headers = {
  accept: "*/*",
  Authorization: `Bearer ${Cookies.get("accessToken")}`,
  "Content-Type": "application/json",
};

export const getPromptByPageId = async (pageId) => {
  const safeId = assertValidPathSegment(pageId, "page id");
  const response = await axiosInstance.get(
    `ai/prompt-masters/get-by-page/${safeId}`,
    { headers }
  );
  return response.data?.result ?? null;
};

export const getActiveAIModelSetups = async () => {
  const response = await axiosInstance.get("ai/model-setups/get-active-list", {
    headers,
  });
  return response.data?.result ?? response.data ?? [];
};

export const generateAIContent = async (payload) => {
  return axiosInstance.post("ai/generate", payload, { headers });
};
